import { useState } from 'react';
import { useWatch } from 'react-hook-form';
import { useDeepCompareEffect } from 'react-use';
import { isNull } from 'lodash';

import {
   Anchor,
   AnchorAlignment,
   ContentNode,
   Notification,
   NotificationSize,
   NotificationType,
} from '@dreryk/react-components';

import { AppointmentFormController } from '../AppointmentForm.types';
import { ReceptionServiceTableBean } from '../../../../../receptionService/extensions/calendar/appointment/interactiveTable/ReceptionServiceInteractiveTable.types';

import { getTotalAdvancePayment, getWarningMessage } from './VisitRequiredAdvancePaymentInfo.utils';

type VisitRequiredAdvancePaymentInfoProps = Pick<AppointmentFormController, 'watch' | 'control'>;

export const VisitRequiredAdvancePaymentInfo = (props: VisitRequiredAdvancePaymentInfoProps): JSX.Element | null => {
   const [message, setMessage] = useState<ContentNode | null>(null);
   const formValues = props.watch();

   const receptionServiceValue = useWatch<ReceptionServiceTableBean[]>({
      name: 'receptionService.value',
      control: props.control,
      defaultValue: formValues.receptionService?.value ?? [],
   });

   useDeepCompareEffect(() => {
      const currentTotalAdvancePayment = getTotalAdvancePayment(receptionServiceValue);
      setMessage(getWarningMessage(currentTotalAdvancePayment));
   }, [receptionServiceValue]);

   if (isNull(message)) {
      return null;
   }

   return (
      <Anchor shouldPerformScroll verticalAlignment={AnchorAlignment.END} testId={'visitRequiredAdvancePaymentInfo'}>
         <Notification
            testId={'visitRequiredAdvancePaymentInfo'}
            type={NotificationType.INFO}
            size={NotificationSize.SMALLER}
            label={message}
         />
      </Anchor>
   );
};
